import {
  DeleteOutlined as DeleteOutlinedAntd,
  SendOutlined as SendOutlinedAntd,
  UserOutlined as UserOutlinedAntd,
} from '@ant-design/icons/lib/icons';
import {
  Button as ButtonAntd,
  Input as InputAntd,
  Table as TableAntd,
} from 'antd';
import styled from 'styled-components';

export const Table = styled(TableAntd)`
  .ant-table {
    border-right: 1px solid #dfdfdf;
    border-bottom: 1px solid #dfdfdf;
  }

  .ant-table,
  .ant-table-thead > tr > th {
    color: #676a6c;
  }

  .ant-table-thead > tr > th {
    font-weight: 700;
    font-size: 12px;
    height: 44px;
    background: #f5f5f6;
    border: 1px solid #dfdfdf;
  }

  table tr > td {
    padding: 0px 16px;
    font-size: 12px;
    border: 1px solid #e6e6e6;
    background: #ffffff;
    height: 56px;
  }
`;

export const Button = styled(ButtonAntd)`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  border: 1px solid #24a95d !important ;
  border-radius: 4px !important;
  box-sizing: border-box;
  margin-right: 8px;
  background: #24a95d;
  color: #fff;

  :hover,
  :active,
  :focus {
    color: #24a95d;
    border: 1px solid #24a95d;
  }
`;

export const FiltroInput = styled(InputAntd)`
  width: 188px;
  margin-bottom: 8px;
  display: block;

  .ant-table-filter-trigger-container {
    position: relative;
  }
`;

export const DeleteOutlined = styled(DeleteOutlinedAntd)`
  color: #ff0000;
  font-size: 20px;

  :hover {
    opacity: 0.6;
  }
`;

export const SendOutlined = styled(SendOutlinedAntd)`
  color: #4190f7;
  font-size: 20px;

  :hover {
    opacity: 0.6;
  }
`;

export const UserOutlined = styled(UserOutlinedAntd)`
  color: #24a95d;
  font-size: 20px;

  :hover {
    opacity: 0.6;
  }
`;

export const ContainerButtons = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
`;

export const ActionButton = styled(ButtonAntd)`
  padding: 0;
  color: #6bbc60;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;

  &:hover {
    color: #6bbc60;
  }
`;
